module.exports = __webpack_public_path__ + "img/gear-G_98x98.d0b479ac.png";